/* eslint-disable import/no-extraneous-dependencies, arrow-body-style,object-curly-newline */
/* global React */
import DocHoc from 'platform/react/hoc/pubsub/doc'
import Section from 'ui/Element/Section'

const SubbedSection = DocHoc(Section)

export default SubbedSection
